<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="">
      <div class="admin-main-container-content">
        @if (promotion.id) {
          <div class="header-title">{{'' | i18n: 'edit-promotion'}}</div>
        }
        @if (!promotion.id) {
          <div class="header-title">{{'' | i18n: 'new-promotion'}}</div>
        }
        <div class="row main-container">
          <div class="col-lg-6" style="margin-left: -30px;">
            <div class="col-lg-12">
              <div class="form-group">
                <label>{{'' | i18n: 'dealer-region'}}:</label>
                <ng-multiselect-dropdown
                  name="regions"
                  [placeholder]="'Select Region...'"
                  [data]="regions"
                  ngDefaultControl
                  [(ngModel)]="promotion.selectedRegions"
                  (ngModelChange)="selectAllDealersInSelectedRegions()"
                  [settings]="dropdownSettings">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="" style="display: flex;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'brand'}}:</label>
                  <select [(ngModel)]="promotion.selectedBrand" (ngModelChange)="fetchContractTypes()">
                    <option value="null">{{'' | i18n: 'select'}}</option>
                    <option value="BMW">BMW</option>
                    <option value="MINI">MINI</option>
                    <option value="BMWi">BMWi</option>
                    <option value="Motorrad">Motorrad</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'model'}}:</label>
                  <ng-multiselect-dropdown name="models"
                    ngDefaultControl
                    [placeholder]="'Select Models...'"
                    [data]="models"
                    [(ngModel)]="promotion.selectedModels"
                    [settings]="dropdownSettings">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div class="" style="display: flex;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'contract-type'}}:</label>
                  <select #contractType id="warranty-contract-TypeId" [(ngModel)]="promotion.selectedContractType"
                    (ngModelChange)="setContractDurations()">
                    <option value="null">{{'' | i18n: 'select'}}</option>
                    @for (c of contractTypes; track c) {
                      <option [ngValue]="c">{{ c.contractType }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'contract-duration'}}:</label>
                  @if (promotion.selectedContractType) {
                    <select #contractCode id="warranty-contract-DurationId"
                      [(ngModel)]="promotion.selectedContractCode">
                      <option value="null">{{'' | i18n: 'select'}}</option>
                      @for (c of promotion.selectedContractType.contractCodes; track c) {
                        <option
                        value="{{c.code}}">{{c.period + ' Months'}}</option>
                      }
                    </select>
                  }
                  @if (!promotion.selectedContractType) {
                    <select id="warranty-contract-"
                      [(ngModel)]="promotion.selectedContractCode">
                      <option value="null">{{'' | i18n: 'select'}}</option>
                    </select>
                  }
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'order-date-from'}}:</label>
                  <input type="date" [(ngModel)]="promotion.dateFrom">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'order-date-to'}}:</label>
                  <input type="date" [(ngModel)]="promotion.dateTo">
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'creation-date-from'}}:</label>
                  <input type="date" [(ngModel)]="promotion.warrantyCreationDateFrom">
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label>{{'' | i18n: 'creation-date-to'}}:</label>
                  <input type="date" [(ngModel)]="promotion.warrantyCreationDateTo">
                </div>
              </div>
            </div>
            <div class="row" style="margin-left: 0px;">
              <div class="col-lg-12">
                <div class="form-group">
                  <label>{{'' | i18n: 'vins-applicable'}}:</label>
                  <textarea [(ngModel)]="vinList"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="col-lg-12">
              <div class="form-group">
                <label>{{'' | i18n: 'vins-dealer'}}(s):</label>
                <ng-multiselect-dropdown
                  [placeholder]="'Select Dealers...'"
                  ngDefaultControl
                  [data]="dealers"
                  name="dealers"
                  [(ngModel)]="promotion.selectedDealers"
                  [settings]="dropdownSettings">
                </ng-multiselect-dropdown>
              </div>

            </div>
            <div class="col-lg-12">
              <div class="form-group">
                <label>{{'' | i18n: 'source'}}:</label>
                <ng-multiselect-dropdown
                  [placeholder]="'Select Vehicle Sources...'"
                  [data]="sources"
                  ngDefaultControl
                  name="sources"
                  [(ngModel)]="promotion.selectedSources"
                  [settings]="dropdownSettings">
                </ng-multiselect-dropdown>
              </div>
              <div class="form-group" style="display: -webkit-inline-box;">
                <label>{{'' | i18n: 'discount'}}* (%)</label>
                <input type="number" [(ngModel)]="promotion.discount">
                <div class="error-text">{{discountError}}</div>
              </div>
              <div class="form-group" style="display: -webkit-inline-box;">
                <label>{{'' | i18n: 'promotion-descr'}}*</label>
                <input type="text" [(ngModel)]="promotion.description">
                <div class="error-text">{{descError}}</div>
              </div>
            </div>
            <div class="col-lg-12">
              <form [formGroup]="uploadForm">
                <div class="container-header-bar" style="padding-top: 8px;">{{'' | i18n: 'upload-promotion'}}:</div>
                <div class="row-container">
                  <input name="document" class="input" formControlName="document" type="file" ng2FileSelect
                    accept=".pdf,.mp4,.jpg,.jpeg,.png" [uploader]="uploader" multiple/>
                  </div>
                  @for (item of uploader.queue; track item) {
                    <div class="container-sub-header-bar" style="padding-top: 8px;">
                      <div class="files-names">{{'' | i18n: 'file-name'}}</div>
                      <div class="files-remove">{{'' | i18n: 'remove'}}</div>
                    </div>
                  }
                </form>
                @for (item of uploader.queue; track item) {
                  <div class="row-container">
                    <div class="files-names">{{ item._file.name }}</div>
                    <div class="files-remove">
                      <button (click)="item.remove()" class="button button-edit">
                        <img src="assets/images/icon-remove.png" width="20px" height="20px" class="table-icon">
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="button_bottom">
            <button class="btn-default-custon" (click)="goBack()">{{'' | i18n: 'cancel'}}</button>
            @if (promotion.id) {
              <button (click)="deletePromotion()">{{'' | i18n: 'delete'}}</button>
            }
            <button (click)="savePromotion()">{{'' | i18n: 'save'}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>



